import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import {
  GlobalSearchResult,
  GlobalSearchService,
} from '../global-search.service';

@Component({
  selector: 'app-global-search-results-box',
  templateUrl: './global-search-results-box.component.html',
  styleUrls: ['./global-search-results-box.component.css'],
})
export class GlobalSearchResultsBoxComponent {
  @Input() results: GlobalSearchResult = {
    contacts: [],
    products: [],
    actions: [],
  };

  @Output() itemClicked = new EventEmitter<void>();

  constructor(
    private globalSearchService: GlobalSearchService,
    private router: Router
  ) {}

  addToHistory(item: any, type: string) {
    this.globalSearchService.addToHistory(item, type);
    this.navigateToItem(item, type);
    this.itemClicked.emit();
  }

  navigateToItem(item: any, type: string) {
    if (type === 'contact') {
      this.router.navigate([`/dashboard/contact/${item.id}/view`]);
    } else if (type === 'product') {
      this.router.navigate([`/dashboard/product/${item.id}`]);
    } else if (type === 'action' && item.link) {
      this.router.navigate([item.link]);
    }
  }
}
